export default "__VITE_ASSET__CnZpHDJ6__"